const getTemplateHeight = (element) => {
  const bounds = element.ownerDocument.documentElement.getBoundingClientRect();
  return bounds.height;
};

export default getTemplateHeight;
